exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "dt[data-v-1c9a66aa], dd[data-v-1c9a66aa] {\n  display: inline-block;\n}\n", ""]);
